import { action } from '@ember/object';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { Args as DataManagerGridItemArgs } from 'webapp/components/data-manager/grid-item';
import DataManagerGridItemComponent from 'webapp/components/data-manager/grid-item';

import type BatchSelect from 'webapp/models-custom/batch-select';
import type SourceType from 'webapp/models-custom/source-type';

interface WizardSourcesGridItemArgs extends DataManagerGridItemArgs {
	batchSelect?: BatchSelect<SourceType> | null;
	isSelected?: boolean;
}

export default class WizardSourcesGridItem extends DataManagerGridItemComponent<WizardSourcesGridItemArgs> {
	@service('current-user') declare currentUserService: Service.CurrentUser;

	override get extraClassNames(): string[] {
		const extraClassNames = [];

		if (this.isSelected) {
			extraClassNames.push('card--selected');
		}

		return extraClassNames;
	}

	override get isOverlayHidden(): boolean {
		return true;
	}

	get isSelected(): boolean {
		const { batchSelect, model, isSelected } = this.args;
		return !!isSelected || !!batchSelect?.isItemSelected(model);
	}

	override get isChecked(): boolean {
		return this.isSelected || (this.isAlreadyConnected && !this.args.hideConnectedFlag);
	}

	@action
	override triggerClick(): void {
		const { model, batchSelect } = this.args;
		batchSelect?.changeSelection(model, !this.isSelected);

		if (this.args.onClick) {
			this.args.onClick(this.args.model);
		}
	}
}
